import { memo } from 'react';

import NextSvg from '@/shared/assets/icons/ui-kit/pagination-next-arrow.svg';
import PrevSvg from '@/shared/assets/icons/ui-kit/pagination-prev-arrow.svg';
import { useMatchMedia } from '@/shared/lib/hooks/use-match-media.hook';

import { getPagesCut, range } from './old-pagination.data';
import * as Styled from './old-pagination.styles';
import { PaginationProps } from './old-pagination.types';

const PAGES_CUT_COUNT_FOR_MOBILE = 1;

// TODO: this component used only in DashboardPaginationComponent, consider removing it in future
const PaginationComponent = ({
	onChangePage,
	page,
	pages,
	pagesCutCount = 5,
	className,
	total,
	children,
}: PaginationProps) => {
	const isMobile = useMatchMedia('mobile');
	const pagesCut = getPagesCut({
		pagesCount: pages,
		pagesCutCount: isMobile ? PAGES_CUT_COUNT_FOR_MOBILE : pagesCutCount,
		currentPage: page,
	});
	const pagesRange = range(pagesCut.start, pagesCut.end);
	const isFirstPage = page === 1;
	const isLastPage = page === pages;

	if (!total) {
		return null;
	}

	return (
		<Styled.Wrapper className={className}>
			<Styled.Arrow Svg={PrevSvg} disabled={isFirstPage} onClick={onChangePage(page - 1)} />
			{pagesRange.map((p) => (
				<Styled.Number key={p} active={page === p} onClick={onChangePage(p)}>
					{p}
				</Styled.Number>
			))}
			<Styled.Arrow Svg={NextSvg} disabled={isLastPage} onClick={onChangePage(page + 1)} />
			{children}
		</Styled.Wrapper>
	);
};

export default memo(PaginationComponent);
